"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconSrc = void 0;
const react_1 = __importDefault(require("react"));
const icons_1 = require("../../icons");
const NotebarStatus_1 = require("../types/NotebarStatus");
const getIconSrc = (status) => {
    switch (status) {
        case NotebarStatus_1.NOTEBAR_STATUS.error:
            return react_1.default.createElement(icons_1.ErrorStatusIcon, null);
        case NotebarStatus_1.NOTEBAR_STATUS.ok:
            return react_1.default.createElement(icons_1.SuccessStatusIcon, null);
        case NotebarStatus_1.NOTEBAR_STATUS.warning:
            return react_1.default.createElement(icons_1.WarningStatusIcon, null);
        default:
            return react_1.default.createElement(icons_1.InfoStatusIcon, null);
    }
};
exports.getIconSrc = getIconSrc;
//# sourceMappingURL=getIconSrc.js.map